var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 222,
    viewBox: "0 0 430 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-108.406 215.906C-108.406 215.906 -95.2706 209.984 -36.8796 108.065C21.5114 6.14576 232.869 -9.30877 350.786 20.673C468.703 50.6547 526.532 122.281 526.532 122.281",
    stroke: "url(#paint0_linear_877_1687)",
    strokeWidth: 12.281
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_877_1687",
    x1: 454.864,
    y1: -0.393634,
    x2: -190.306,
    y2: 95.8991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367314,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73372,
    stopColor: "#FFB800",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve);
export default __webpack_public_path__ + "static/media/curve.a24a7a7ae753550642a166e1b89df777.svg";
export { ForwardRef as ReactComponent };